module.exports = __webpack_public_path__ + "img/anish.a998ee0c.png";